module.exports = __webpack_public_path__ + "static/media/orochi__hero.9339552d.jpeg";